<template>
  <div class="col-xs-10 col-sm-10 grid_div" id="grid_right_div">
    <!--<div id="flushBtn"></div>-->
    <div id="contentDiv">
      <div class="head_title">
        <div class="head_title_font">餐饮菜单&gt;</div>
      </div>

      <div class="body_content">
        <div class="body_top">
          <button type="button" class="btn btn-default btn_option" data-toggle="modal" data-target="#myModal" style="width: 140px">
            新增
          </button>
          <div class="searcharea">
            <select class="form-control" v-model="searchParams.type" placeholder="课程类型">
              <option selected value="">- 请选择类型</option>
              <option v-for="(t, key, index) in menu_type" :value="key">{{t}}</option>
            </select>

            <input class="form-control" placeholder="名称"  v-model="searchParams.name"/>
            <button type="button" class="btn btn-default btn_option" @click="initDataList()">查询</button>
          </div>
        </div>
        <div class="classList_div">
          <table class="table table-striped table-bordered table_trainingManage">
            <thead>
            <tr>
              <th width="15%">图片</th>
              <th width="25%">名称</th>
              <th width="10%">类型</th>
              <th >描述</th>
              <th width="15%">序号</th>
              <th width="15%">操作</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(d, index) in dataList" :key="index">
              <td><a class="picbox" @click="openImageModal(d.filePath)" href="#" v-if="d.filePath">
                <img :src="resourcePath + d.filePath"/>
                <div class="glyphicon glyphicon-remove" @click.stop="deleteAttachmentsFile(d.attachmentId)"></div>
              </a></td>
              <td>{{d.name}}</td>
              <td>{{d.type|formatType}}</td>
              <td>
                <div class="description-content">
                  {{d.description}}
                </div>
              </td>
              <td>{{d.ord}}</td>
              <td>

                <div class="upload_pic" @click="uploadPic(d)"></div>
                <div class="edit_pic" data-toggle="modal"
                     @click="edit(d)">
                </div>
                <div class="delete_pic" @click="deleteById(d.id)"></div>
              </td>
            </tr>
            </tbody>
          </table>
          <page-view v-bind="searchParams"></page-view>
          <!--新增或修改-->
          <div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
            <div class="modal-dialog">
              <div class="modal-content modal-work-content">
                <div class="modal-header">
                  <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                  <h4 class="modal-title" id="myModalLabel">
                    {{option_flag=="add"?'新增':'修改'}}
                  </h4>
                </div>
                <div class="modal-body modal_work_trainingManage">
                  <div>
                    <input type="text" class="form-control modelInput" v-validate="'required|maxL:50'" data-vv-scope="scope" data-vv-as="名称" name="name" placeholder="输入名称" v-model="data.name">
                    <span class="spanRed">*</span>
                    <span class="validateTip">{{ errors.first('scope.name') }}</span>

                    <select class="form-control modelInput" v-model="data.type" placeholder="类型" v-validate="'required'" data-vv-scope="scope" data-vv-as="类型" name="type">
                      <option selected value="" disabled>- 请选择类型</option>
                      <option v-for="(t, key, index) in menu_type" :value="key">{{t}}</option>
                    </select>
                    <span class="spanRed">*</span>
                    <span class="validateTip">{{ errors.first('scope.type') }}</span>

                    <input type="text" class="form-control modelInput" v-validate="'required|numeric'" data-vv-scope="scope" data-vv-as="序号" name="ord" placeholder="输入序号" v-model="data.ord" autocomplete="off">
                    <span class="spanRed">*</span>
                    <span class="validateTip">{{ errors.first('scope.ord') }}</span>

                    <input type="text" class="form-control modelInput" v-validate="'maxL:200'" data-vv-scope="scope" data-vv-as="描述" name="description" placeholder="输入描述" v-model="data.description" autocomplete="off">
                    <span class="spanRed"></span>
                    <span class="validateTip">{{ errors.first('scope.description') }}</span>

                  </div>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-default" @click="saveData()">确定</button>
                  <button type="button" class="btn btn-default" data-dismiss="modal">取消</button>
                </div>
              </div>
            </div>
          </div>

          <!-- 上传 -->
          <div class="modal fade" id="uploadModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                  <h4 class="modal-title" >
                    图片上传
                  </h4>
                </div>
                <div class="modal-body">
                  <!--上传-->
                  <uploader :options="upload.options" :file-status-text="upload.statusText" class="uploader-example" ref="uploader">
                    <uploader-unsupport></uploader-unsupport>
                    <uploader-drop>
                      <p>拖拽文件至此处</p>
                      <uploader-btn :attrs="upload.attrs.image">选择图片</uploader-btn>
                    </uploader-drop>
                    <uploader-list></uploader-list>
                  </uploader>
                </div>
              </div>
            </div>
          </div>

          <!--图片显示-->
          <div class="modal fade" id="myModal_showImage" tabindex="-1" role="dialog" aria-labelledby="myModalLabel_showImage" aria-hidden="true" data-backdrop='static'>
            <div class="modal-dialog modal-dialog-look">
              <div class="modal-content">
                <div class="modal-header">
                  <button type="button" class="close" data-dismiss="modal" aria-hidden="true">
                    &times;
                  </button>
                  <h4 class="modal-title" id="myModalLabel_showImage">
                    图片预览
                  </h4>
                </div>
                <div class="modal-body modal-body-look">
                  <img :src="previewFilePath" class="previewImg"/>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {schoolAxios} from '../main';
  import {getContentSize} from './mainView';
  import pageView from './pageView';
  import dictionaryData from '../json/dictionary';
  import {Validator} from 'vee-validate';

  export default {
    name: "trainingManage",
    components:{pageView},
    data() {
      return {
        clazzId: this.$store.state.clazzId,
        publishStatus: this.$store.state.publishStatus,
        classStatus: this.$store.state.classStatus,
        userId:this.$store.state.userId,
        resourcePath:  this.$store.state.serviceBase + "resources/",
        //教务领导
        leaderUserCode: this.$store.state.leaderUserCode,
        userCode: this.$store.state.userCode,

        //今日日期
        timeDate: '',
        //培训人员集合
        dataList:[],

        option_flag: 'add',

        //培训人员对象
        data:{
          id:'',
          name:'',
          type:'',
          description:'',
          ord:''
        },
        menu_type: dictionaryData.menu_type,
        searchParams: {
          name:'',
          type:"",
          all: 0,
          rows: 10,
          page:1
        },
        //上传
        uploadIds: '',
        upload: {
          uploader: null,
          options: {
            target: this.$store.state.serviceBase + 'upload/upload.action',
            method: 'post',
            headers: {
              'Authorization': this.$store.state.token_type + " " + this.$store.state.access_token
            },
            query: {
            },
            simultaneousUploads: 1,//同时上传数
            testChunks: false,
            chunkSize: 10*1024*1024*1024,//分片大小：10G
          },
          attrs: {
            image: {
              accept: 'image/*'
            },
          },
          statusText: {
            success: '成功了',
            error: '出错了',
            uploading: '上传中',
            paused: '暂停中',
            waiting: '等待中',
          },
        },
        previewFilePath:""
      }
    },
    filters: {
      formatType(value){
        let this_ = this;
        if(dictionaryData.menu_type && value){
          value = dictionaryData.menu_type[value];
        }
        return value;
      }
    },
    created: function () {

    },
    mounted: function () {
      let this_ = this;
      this.$nextTick(function () {
        getContentSize();

        this_.initDataList();//日期

        //绑定加载关闭模态框时的事件
        this_.closeModal();
        this_.searchParams.page = 1;
        this_.searchParams.pageCallback = this_.initDataList;
        //获得上传组件对象
        this_.upload.uploader = this_.$refs.uploader.uploader;
        //上传组件绑定事件
        this_.loadUpload();
      });
    },
    methods: {
            /**
       * 加载培训人员列表
       */
      initDataList(pageParams){
        let this_ = this;
        if(pageParams)
          Object.assign(this_.searchParams, pageParams);

        let _searchParams = {};
        Object.assign(_searchParams, this_.searchParams);
        delete _searchParams.pageCallback;//提交前删除回调
        schoolAxios({
          method: 'get',
          url: 'cateringMenu/findPage',
          params: _searchParams
        }).then(function (resp) {
          if(resp.data.success){
            // console.info(this_.userId);
            this_.dataList = resp.data.list;
            this_.searchParams.all = resp.data.totalPage;
            this_.searchParams.page = 1;
          }
        });
      },

      /**
       * 添加培训人员
       */
      saveData(){
        let this_ = this;
        this_.$validator.validateAll('scope').then(result => {
          if (result) {
            let method = "";
            let url = "";
            if (this_.option_flag == "add") {
              method = "post";
              url = "cateringMenu/add";
            } else {
              method = "put";
              url = "cateringMenu/edit";
            }
            schoolAxios({
              method: method,
              url: url,
              data: this_.data
            }).then(function (resp) {
              let data = resp.data;
              if (data.success) {
                $("#myModal").modal("hide");
                this_.initDataList();
                // "保存成功".showMessage();
              } else {
                (data.message||"保存失败").showMessage();
              }
            });
          }
        });
      },

      edit(d){
        let this_ = this;
        this_.data = d;
        this_.option_flag = "edit"
        $("#myModal").modal("show");
      },


      /**
       * 删除培训人员
       */
      deleteById(id){
        let this_ = this;
        "确定删除".showConfirm(function () {
          schoolAxios({
            method: 'delete',
            url: 'cateringMenu/delete/'+id,
            params: {}
          }).then(function (resp) {
            let data = resp.data;
            if(data.success){
              // "删除成功".showMessage();
              this_.initDataList();
            }else{
              (data.message||"删除失败").showMessage();
            }
          })
        })
      },

      /**
       * 关闭模态框监听
       */
      closeModal() {
        let this_ = this;
        $("#myModal").on('hide.bs.modal', function () {
          this_.searchTeacherName = '';
          this_.queryInputDataArr = [];
          this_.data = {
            id:'',
            name:'',
            type:'',
            description:'',
            ord:''
          }
          this_.option_flag= 'add';
          setTimeout(function () {
            this_.errors.clear('scope');
          });

        });
        $("#uploadModal").on('hide.bs.modal', function () {
          if(this_.upload.uploader)
            this_.upload.uploader.cancel();
          this_.attachmentIds = "";
        });

      },
      relationAttachment(){
        let this_ = this;
        schoolAxios({
          method: 'post',
          url: 'upload/relation.action',
          data: {
            'formObjId': this_.data.id,
            'uploadAttachmentIds': this_.attachmentIds,
          }
        }).then(function (resp) {
          let data = resp.data;
          if (data.success) {
            "上传成功".showMessage();
            this_.initDataList();
            $("#uploadModal").modal('hide');
          }
        });
      },
      /**
       * 上传加载
       */
      loadUpload(){
        let this_ = this;
        this_.upload.uploader.on('fileAdded', function (file, event) {
          if(file.fileType.indexOf("image")==-1){
            (file.name+"不是所需格式文件，请重新选择正确的格式文件上传").showMessage();
            return false;
          }
        })
        this_.upload.uploader.on('fileSuccess', function (rootFile, file, message, chunk) {
          //console.info(message);
          if(message){
            let message_ = JSON.parse(message);
            if(this_.uploadIds != ""){
              this_.uploadIds += ",";
            }
            this_.uploadIds += message_.message;
            if(this_.attachmentIds != ""){
              this_.attachmentIds += ",";
            }
            this_.attachmentIds += message_.message;
            this_.relationAttachment();
          }
        })
        this_.upload.uploader.on('fileComplete', function (rootFile) {
          //console.info(rootFile);

        })
        this_.upload.uploader.on('fileError', function (rootFile, file, message) {
          (file.name+"上传失败").showMessage();
        })
      },

      /**
       * 打开图片模态框
       */
      openImageModal(filePath) {
        let this_ = this;
        this_.previewFilePath = this_.resourcePath + filePath;
        $("#myModal_showImage").modal("show");
      },
      /**
       * 上传图片
       */
      uploadPic(d){
        let this_ = this;
        if(d.filePath){
          "更新图片请先删除原图片".showMessage();
          return;
        }
        this_.data = {
          id: d.id
        };
        $("#uploadModal").modal('show');

      },

      deleteAttachmentsFile(id){
        let this_ = this;
        "确定删除图片吗？".showConfirm(function () {
          schoolAxios({
            method: 'delete',
            url: 'upload/delete.action',
            params: {
              uploadAttachmentId: id
            }
          }).then(function (resp) {
            let data = resp.data;
            if(data.success){
              this_.initDataList();
            }else{
              (data.message||"删除失败").showMessage();
            }
          })
        })
      },

    }
  }
</script>

<style scoped>
  @import '../assets/css/plugins.css';
  @import "../assets/css/publicStyle.css";
  .body_top {
    margin: 20px 0;
  }
  .searcharea{
    width: 80%;
    float: right;
    text-align: right;
  }
  .searcharea .form-control{
    display: inline-block;
    width: 160px;
  }
  .searcharea button{
    width: 60px;
  }
  .table_trainingManage {
    margin: 20px 0 0 0;
  }
  table tr{
    text-align: center;
  }
  table th {
    background: #cccccc;
    text-align: center;
  }
  .table-striped {
    /*background-color: #D7D7D7;*/
  }
  .edit_pic {
    width: 29px;
    height: 22px;
    background-image: url("../assets/img/right/trainingManage/edit_mouseOver.png");
    background-size: 100% 100%;
    float: left;
    margin: 0 25px 0 25px;
  }
  .delete_pic {
    width: 29px;
    height: 22px;
    background-image: url("../assets/img/right/trainingManage/delete_mouseOver.png");
    background-size: 100% 100%;
    float: left;
  }
  .modelInput{
    height: 34px;
    width: 90%;
    margin-top: 2%;
    margin-left: 5%;
  }
  #teachers_div {
    position: absolute;
    left: 42px;
    width: 86%;
    border: 1px grey solid;
    background-color: white;
    display: none;
  }
  #teachers_div option {
    height: 30px;
    line-height: 30px;
    text-align: left;
  }
  #teachers_div option:hover {
    background-color: grey;
  }
  .form-control.modelInput {
    display: inline-block;
    width: 92%;
  }
  .show_edit_pic {
    background-image: url("../assets/img/right/clazz/edit_mouseOver.png");
    cursor: pointer;
  }
  .table_trainingManage tbody{
    height: 680px;
  }
  .description-content{
    width: 100%;
    height: 90px;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
  }
  .picbox{
    height: 102px;
    width: 82px;
    display: inline-block;
    position: relative;
  }
  .picbox img{
    height: 100px;
    width: 80px;
  }
  .picbox div{
    position: absolute;
    top: 1px;
    right: 1px;
  }
  .upload_pic {
    width: 29px;
    height: 22px;
    background-image: url("../assets/img/right/clazz/pic.png");
    background-size: 100% 100%;
    float: left;
  }
  .uploader-drop {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/cateringMenu.vue